/**
 * GA4 loader for OEProfile — mirrors OEServer ga4-analytics.js + applyGrantedSurfaceLoaders.
 */
import ReactGA from 'react-ga4';
import { createBrowserHistory } from 'history';
import {
  GA4_MEASUREMENT_ID_PROFILE,
  getGa4MeasurementId,
  grantGa4Consent,
  revokeGa4ConsentMode,
} from './analyticsConfig';

let gaInitialized = false;
let gaMeasurementAllowed = false;

function gaDisableKey(measurementId) {
  return `ga-disable-${measurementId}`;
}

function resolveMeasurementId() {
  return getGa4MeasurementId() || GA4_MEASUREMENT_ID_PROFILE;
}

/** Stop hits from an already-loaded gtag / react-ga4 (Consent Mode revoke alone is not enough). */
export function stopGa4Measurement() {
  gaMeasurementAllowed = false;
  revokeGa4ConsentMode();
  const measurementId = resolveMeasurementId();
  if (typeof window !== 'undefined' && measurementId) {
    window[gaDisableKey(measurementId)] = true;
    if (typeof window.gtag === 'function') {
      window.gtag('config', measurementId, { send_page_view: false });
    }
  }
}

function allowGa4Measurement() {
  const measurementId = resolveMeasurementId();
  if (typeof window !== 'undefined' && measurementId) {
    window[gaDisableKey(measurementId)] = false;
  }
  gaMeasurementAllowed = true;
}

/** @internal Test-only reset for module singleton state. */
export function __resetGa4ForTests() {
  gaInitialized = false;
  gaMeasurementAllowed = false;
  const measurementId = resolveMeasurementId();
  if (typeof window !== 'undefined' && measurementId) {
    delete window[gaDisableKey(measurementId)];
  }
}

export function isGa4Initialized() {
  return gaInitialized;
}

export function initGA() {
  if (gaInitialized) {
    return;
  }
  const measurementId = getGa4MeasurementId() || GA4_MEASUREMENT_ID_PROFILE;
  if (!measurementId) {
    return;
  }
  grantGa4Consent();
  ReactGA.initialize(measurementId);
  gaInitialized = true;
}

export function logPageView(page) {
  if (!gaInitialized || !gaMeasurementAllowed) return;
  let pagePath = page;
  if (!pagePath) {
    const history = createBrowserHistory();
    pagePath = history.location.pathname + (history.location.search || '');
  }
  ReactGA.send({ hitType: 'pageview', page: pagePath });
}

/**
 * @param {boolean} analyticsAccepted From hasAcceptedAnalytics() (live Didomi + cache).
 */
export function applyGrantedGa4Loaders(analyticsAccepted) {
  if (analyticsAccepted === true) {
    allowGa4Measurement();
    initGA();
  } else {
    stopGa4Measurement();
  }
}
